"use client";

import { Ref } from "react";
import { Plus } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button, Stack, Text } from "@leabankab/component-library";

interface EmptyDebtsCardProps {
	onAdd: () => void;
	ref?: Ref<HTMLButtonElement>;
}

/** Shown until the first debt exists, in place of the plain add button. */
export const EmptyDebtsCard = ({ onAdd, ref }: EmptyDebtsCardProps) => {
	const t = useTranslations("pages.RefinancePage");

	// `text.subtle` only meets 4.5:1 on a plain white surface.
	return (
		<Stack
			gap={2}
			align="center"
			className="rounded-xl border border-border-subtle bg-bg-base p-3 text-center"
		>
			<div className="flex size-6 items-center justify-center rounded-full border border-border-subtle bg-bg-base text-primary-base">
				<Plus size={20} aria-hidden="true" />
			</div>

			<Stack gap={0.5}>
				<Text fontWeight="medium" color="text.base">
					{t("debtList.empty.title")}
				</Text>
				<Text textStyle="body-sm" color="text.subtle">
					{t("debtList.empty.description")}
				</Text>
			</Stack>

			<Button ref={ref} onClick={onAdd} className="w-full">
				{t("debtList.addButton.title")}
			</Button>
		</Stack>
	);
};
